import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { setOrderAction } from '~src/spacesPlatform/actions/SetOrderAction';
import { getOrderClausesFromQueryParam } from '~src/spacesPlatform/components/Explorer/ExplorerUrlBindings';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { UrlParamKeys } from '../../app/UrlParamKeys';
import { Messages } from '../../codegen/Localize';
import { getDefaultOrderForFlowSubSpace } from '../../ts/models/sort/SortOptionDefinitions';
import { EnterFlowSubspaceReduxAction } from '../actions/EnterFlowSubspaceAction';

export function* handleEnterFlowSubspace(action: EnterFlowSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.flowDetailInfo,
      spaceType: 'flow',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    const hashQuery: any = WindowLocationService.getHashQueryObject();
    const orderFromQuery = getOrderClausesFromQueryParam(
      hashQuery[UrlParamKeys.Order],
      getDefaultOrderForFlowSubSpace(spaceInfo)
    );
    yield put(setOrderAction(orderFromQuery));
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
